// ============================================================
// Full path:
//   D:\Thyroid Consultation Software\ThyroConsult Frontend\thyroconsult-frontend\src\i18n\en.js
//
// English DISPLAY wording (14 Oct 2026). Some English texts in the code are
// also names that reports and answers are matched by (e.g. the report box
// "T3 (total)"), so the code text itself must not change. This file says
// how such a text is SHOWN on English pages instead — following the style
// guide: FULL form first, SHORT form in brackets, e.g.
//   "CBC (Complete Blood Count)" is shown as "Complete Blood Count (CBC)".
//
// Left side  = the exact English text used in the code (also the key in
//              hi.js and every other language file — those stay unchanged).
// Right side = what an English page shows.
// Report boxes always send the code text to the server (never the shown
// text), so report matching is not affected.
// ============================================================

const EN = {
  // Tests — full form first, short form in brackets
  'CBC (Complete Blood Count)': 'Complete Blood Count (CBC)',
  'T3 (total)': 'Total Triiodothyronine (T3)',
  'T4 (total)': 'Total Thyroxine (T4)',
  'Total T3 (T3)': 'Total Triiodothyronine (T3)',
  'Total T4 (T4)': 'Total Thyroxine (T4)',
  'Free T3 (FT3)': 'Free Triiodothyronine (FT3)',
  'Free T4 (FT4)': 'Free Thyroxine (FT4)',
  'TSH (thyroid stimulating hormone)': 'Thyroid Stimulating Hormone (TSH)',
  'T3 (total triiodothyronine)': 'Total Triiodothyronine (T3)',
  'T4 (total thyroxine)': 'Total Thyroxine (T4)',
  'Anti-Tg (Anti-thyroglobulin) antibody': 'Anti-thyroglobulin (Anti-Tg) antibody',
  'PTH (Parathyroid hormone)': 'Parathyroid Hormone (PTH)',
  'CEA (Carcinoembryonic antigen)': 'Carcinoembryonic Antigen (CEA)',
  'FNAC (Fine needle aspiration cytology)': 'Fine Needle Aspiration Cytology (FNAC)',
  'RAI (Radioiodine)': 'Radioactive Iodine (RAI)',
  'AFTN (Single toxic nodule)': 'Autonomously Functioning Thyroid Nodule (AFTN)',

  // Questions
  'Have you had a Total T3 (T3) test done?': 'Have you had a Total Triiodothyronine (T3) test done?',
  'Have you had a Total T4 (T4) test done?': 'Have you had a Total Thyroxine (T4) test done?',
  'Have you had a Free T3 (FT3) test done?': 'Have you had a Free Triiodothyronine (FT3) test done?',
  'Have you had a Free T4 (FT4) test done?': 'Have you had a Free Thyroxine (FT4) test done?',
  'Have you had a TSH (Thyroid Stimulating Hormone) test done?': 'Have you had a Thyroid Stimulating Hormone (TSH) test done?',
  'Have you had a thyroid FNAC (Fine Needle Aspiration Cytology) or Core Biopsy done?': 'Have you had a thyroid Fine Needle Aspiration Cytology (FNAC) or Core Biopsy done?',
  'Has an FNAC (fine needle aspiration) been done?': 'Has a Fine Needle Aspiration Cytology (FNAC) been done?',
  'Have you had an Anti-TPO (Anti-Thyroperoxidase) antibody test done?': 'Have you had an Anti-thyroperoxidase (Anti-TPO) antibody test done?',
  'Have you had an Anti-Tg (Anti-thyroglobulin) antibody test done?': 'Have you had an Anti-thyroglobulin (Anti-Tg) antibody test done?',
  'Have you had Anti-TPO or Anti-thyroglobulin (Anti-Tg) antibodies tested?': 'Have you had Anti-thyroperoxidase (Anti-TPO) or Anti-thyroglobulin (Anti-Tg) antibodies tested?',
  'Have you had an Anti-TPO antibody test done?': 'Have you had an Anti-thyroperoxidase (Anti-TPO) antibody test done?',
};

export default EN;
